import axios from "../../config/axiosConfig";

export async function updateUserInfos(userId, userData) {
  if (!userId || !userData) {
    return { success: false, msg: "Données manquantes" };
  }

  try {
    await axios.patch(`/users/${userId}`, userData);

    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("updateUserInfos service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la mise à jours de vos données",
      };
    }
  }
}

export async function changeEmail(userId, userData) { 
  if (!userId || !userData) {
    return { success: false, msg: "changeEmail Données manquantes" };
  }

  try {
    await axios.patch(`/users/${userId}/change-email`, userData);

    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("updateUserInfos service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la mise à jours de vos données",
      };
    }
  }
}

export async function changePassword(
  userId,
  currentPassword = "",
  newPassword = ""
) {
  if (!userId || !currentPassword || !newPassword) {
    return { success: false, msg: "changePassword Données manquantes" };
  }

  try {
    await axios.patch(`/users/${userId}/change-password`, {
      currentPassword,
      newPassword,
    });

    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("changePassword service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la tentative du changement de mot de passe",
      };
    }
  }
}

export async function updateNotificationPreference(
  userId,
  emails,
  sms = "",
  pregression = ""
) {
  return { success: true, msg: "" };
  // try {
  //   await axios.patch(`/users/${userId}/change-password`, {
  //     currentPassword,
  //     newPassword,
  //   });
  //   return { success: true, msg: "" };
  // } catch (error) {
  //   if (error.response?.data) {
  //     console.error("API Error:", error.response.data);
  //     const { data } = error.response;
  //     return {
  //       success: false,
  //       msg: data.message,
  //     };
  //   } else {
  //     console.error("changePassword service error:", error.message);
  //     return {
  //       success: false,
  //       msg: "une erreur s'est produite lors de la tentative du changement de mot de passe",
  //     };
  //   }
  // }
}

export async function updateLanguagePreference(userId, language) {
  if (!userId || !language) {
    return { success: false, msg: "updateLanguage Données manquantes" };
  }

  try {
    await axios.patch(`/users/language`, {
      userId,
      language,
    });
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;
      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("updateLanguage service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la tentative du changement de la langue",
      };
    }
  }
}

export async function updateImage(userId, image) {
  const formData = new FormData();
  formData.append("image", image); 
  try {
    const response = await axios.put(
      `/users/update-image/${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return { success: true, msg: "", data: response.data };
  } catch (error) {
    console.error("Erreur updateImage:", error);
    return {
      success: false,
      msg: error.response?.data?.message || "Erreur inattendue",
    };
  }


  
}
export const checkEmailExistence = async (email, currentUserId) => {
  const response = await axios.get(`/users/check-email`, {
    params: { email, currentUserId },
  });
  return response.data.exists;
};